export const getBackupCodesFileName = () =>
  `scalar-backup-codes-${new Date().toLocaleDateString('en-US').replace(/\//g, '-')}.pdf`;
